import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const TabOne = () => {
    return (
        <div>
            <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row row--30 align-items-center">
                                <div className="col-lg-5">
                                    <img className="radius-small" src='./images/tab/tabs-01.jpg' alt="Business strategy and development overview" />
                                </div>
                                <div className="col-lg-7 mt_md--40 mt_sm--40">
                                    <div className="rn-default-tab">
                                        <div className="tab-button-panel">
                                            <TabList className="tab-button" role="tablist" aria-label="Business process tabs">
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-strategy">
                                                    <div className="rn-tab-button">
                                                        <button type="button">Strategy</button>
                                                    </div>   
                                                </Tab>
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-reporting">
                                                    <div className="rn-tab-button">
                                                        <button type="button">Reporting</button>
                                                    </div>   
                                                </Tab>
                                                <Tab role="tab" aria-selected="false" aria-controls="tab-panel-development">
                                                    <div className="rn-tab-button">
                                                        <button type="button">Development</button>
                                                    </div>   
                                                </Tab>
                                            </TabList>
                                        </div>

                                        <div className="tab-content-panel">
                                        <TabPanel role="tabpanel" aria-labelledby="tab-strategy">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>

                                                        <p>Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                            
                                            <TabPanel role="tabpanel" aria-labelledby="tab-reporting">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Ipsum lorem dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>

                                                        <p>Ipsa Quibusdam, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>

                                            <TabPanel role="tabpanel" aria-labelledby="tab-development">
                                                <div className="rn-tab-content">
                                                    <div className="inner">
                                                        <p>Exercitationem Ipsum lorem dolor sit amet consectetur, adipisicing elit. Quibusdam ipsa, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla  tempore corrupti! Nemo.</p>

                                                        <p>Ipsa Quibusdam, deleniti soluta minima minus asperiores doloribus enim vitae obcaecati fuga assumenda laudantium nemo odio provident nulla exercitationem tempore corrupti! Nemo.</p>
                                                    </div>
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
        </div>
    )
}

export default TabOne
